const resource = 'favorites'

export default $axios => ({
  fetch(params) {
    return $axios.$get(`/${resource}`, { params })
  },
  get(id, params) {
    return $axios.$get(`/${resource}/${id}`, { params })
  },
  delete(id) {
    return $axios.$delete(`/v2/favorites/${id}`)
  },
  create(params) {
    return $axios.$post(`/${resource}`, params)
  },
  fetchAccountFavorites(params) {
    return $axios.$get('/v2/account/favorites', { params })
  },

  getServiceName: name => 'favoriteService',
})
